<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Caja diaria
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Finanzas</span>
      <span> /</span>
      <span>Caja diaria</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body align-items-center">
        <div class="col d-flex align-items-center justify-content-between">
          <div class="md-form mb-2">
            <mdb-date-picker [inline]="true" name="fechaCaja" formControlName="fechaCaja" [placeholder]="'Fecha'"
              required></mdb-date-picker>
          </div>
          <div>
            <button size="sm" class="btn btn-sm" type="button" mdbBtn color="info" (click)="detalle()" mdbWavesEffect>
              Detalle
            </button>
            <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect (click)="buscar()">
              Reporte de Caja Diaria
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <!-- <h4>Venta del Periodo = <strong>89.999.999</strong></h4> -->
    <div class="row">
      <!-- LEFT TABLES -->
      <div class="col" style="max-width: 60%;">
        <!-- Recaudación en Recorrido (TRANSPORTISTA) -->
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientosTrasportista">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col" style="min-width: 350px;">
                  Recaudación en Recorrido (TRANSPORTISTA)
                </th>
                <th scope="col" class="text-right">Ingresos</th>
                <th scope="col" class="text-right">Egresos</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="100%" style="text-align: center" *ngIf="loading">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
                <td colspan="100%" style="text-align: center"
                  *ngIf="!loading && listaMovimientosTrasportista?.length === 0">
                  No se encontró información
                </td>
              </tr>
              <tr>
                <td>Efectivo</td>
                <td class="text-right"><strong>{{listaMovimientosTrasportista.monto_efectivo | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Documento / Cheques</td>
                <td class="text-right"><strong>{{listaMovimientosTrasportista.monto_cheque | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Depositos</td>
                <td class="text-right"><strong>{{listaMovimientosTrasportista.monto_deposito | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Transferencia</td>
                <td class="text-right"><strong>{{listaMovimientosTrasportista.monto_transferencia | numerico}}</strong>
                </td>
                <td></td>
              </tr>
              <tr *ngFor="let ban of listaMovimientosTrasportista.bancos">
                <td style="font-size: 12px; padding-left: 20px;">
                  {{ ban.nombre }}
                </td>
                <td class="text-right" style="font-size: 12px; padding-left: 20px;">
                  {{ ban.monto_transferencia | numerico}}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Credito</td>
                <td class="text-right"><strong>{{listaMovimientosTrasportista.monto_credito | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Diferencial (+/-)</td>
                <td align="right"><strong>$ {{listaMovimientosTrasportista.diferencia_monto_ingreso | numerico}}</strong></td>
                <td align="right"><strong>$ {{listaMovimientosTrasportista.diferencia_monto_egreso | numerico}}</strong></td>
              </tr>
              <tr>
                <td>Pago a Cuenta Utilizado</td>
                <td></td>
                <td class="text-right"><strong>{{listaMovimientosTrasportista.pago_cuenta_utilizado |
                    numerico}}</strong>
                </td>
              </tr>
              <tr>
                <td>Gasto Ruta</td>
                <td></td>
                <td class="text-right"><strong>{{listaMovimientosTrasportista.gasto | numerico}}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Recaudación fuera de Recorrido (VENDEDORES) -->
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientosVendedores">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col" style="min-width: 350px;">
                  Recaudación fuera de Recorrido (VENDEDORES)
                </th>
                <th scope="col" class="text-right">Ingresos</th>
                <th scope="col" class="text-right">Egresos</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="100%" style="text-align: center" *ngIf="loading">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
                <td colspan="100%" style="text-align: center"
                  *ngIf="!loading && listaMovimientosVendedores?.length === 0">
                  No se encontró información
                </td>
              </tr>
              <tr>
                <td>Efectivo</td>
                <td class="text-right"><strong>{{listaMovimientosVendedores.monto_efectivo | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Documento / Cheques</td>
                <td class="text-right"><strong>{{listaMovimientosVendedores.monto_cheque | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Depositos</td>
                <td class="text-right"><strong>{{listaMovimientosVendedores.monto_deposito | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Transferencia</td>
                <td class="text-right"><strong>{{listaMovimientosVendedores.monto_transferencia | numerico}}</strong>
                </td>
                <td></td>
              </tr>
              <tr *ngFor="let ban of listaMovimientosVendedores.bancos">
                <td style="font-size: 12px; padding-left: 20px;">
                  {{ ban.nombre }}
                </td>
                <td class="text-right" style="font-size: 12px; padding-left: 20px;">
                  {{ ban.monto_transferencia | numerico}}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Credito</td>
                <td class="text-right"><strong>{{listaMovimientosVendedores.monto_credito | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Diferencial (+/-)</td>
                <td align="right"><strong>$ {{listaMovimientosVendedores.diferencia_monto_ingreso | numerico}}</strong></td>
                <td align="right"><strong>$ {{listaMovimientosVendedores.diferencia_monto_egreso | numerico}}</strong></td>
              </tr>
              <tr>
                <td>Pago a Cuenta Utilizado</td>
                <td></td>
                <td class="text-right"><strong>{{listaMovimientosVendedores.pago_cuenta_utilizado | numerico}}</strong>
                </td>
              </tr>
              <tr>
                <td>Gasto de Ventas</td>
                <td></td>
                <td class="text-right"><strong>{{listaMovimientosVendedores.gasto | numerico}}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Recaudación por caja (Oficina directa) -->
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientosCajaLocal">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col" style="min-width: 350px;">
                  Recaudación por caja (Oficina directa)
                </th>
                <th scope="col" class="text-right">Ingresos</th>
                <th scope="col" class="text-right">Egresos</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="100%" style="text-align: center" *ngIf="loading">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
                <td colspan="100%" style="text-align: center"
                  *ngIf="!loading && listaMovimientosCajaLocal?.length === 0">
                  No se encontró información
                </td>
              </tr>
              <tr>
                <td>Efectivo</td>
                <td class="text-right"><strong>{{listaMovimientosCajaLocal.monto_efectivo | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Documento / Cheques</td>
                <td class="text-right"><strong>{{listaMovimientosCajaLocal.monto_cheque | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Depositos</td>
                <td class="text-right"><strong>{{listaMovimientosCajaLocal.monto_deposito | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Transferencia</td>
                <td class="text-right"><strong>{{listaMovimientosCajaLocal.monto_transferencia | numerico}}</strong>
                </td>
                <td></td>
              </tr>
              <tr *ngFor="let ban of listaMovimientosCajaLocal.bancos">
                <td style="font-size: 12px; padding-left: 20px;">
                  {{ ban.nombre }}
                </td>
                <td class="text-right" style="font-size: 12px; padding-left: 20px;">
                  {{ ban.monto_transferencia | numerico}}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Credito</td>
                <td class="text-right"><strong>{{listaMovimientosCajaLocal.monto_credito | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Diferencial (+/-)</td>
                <td align="right"><strong>$ {{listaMovimientosCajaLocal.diferencia_monto_ingreso | numerico}}</strong></td>
                <td align="right"><strong>$ {{listaMovimientosCajaLocal.diferencia_monto_egreso | numerico}}</strong></td>
              </tr>
              <tr>
                <td>Pago a Cuenta Utilizado</td>
                <td></td>
                <td class="text-right"><strong>{{listaMovimientosCajaLocal.pago_cuenta_utilizado | numerico}}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- RESUMEN-->
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientosResumen">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col" style="min-width: 350px;">RESUMEN</th>
                <th scope="col" class="text-right">Ingresos</th>
                <th scope="col" class="text-right">Egresos</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="100%" style="text-align: center" *ngIf="loading">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
                <td colspan="100%" style="text-align: center" *ngIf="!loading && listaMovimientosResumen?.length === 0">
                  No se encontró información
                </td>
              </tr>
              <tr>
                <td>Efectivo</td>
                <td class="text-right"><strong>{{listaMovimientosResumen.monto_efectivo | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Documento / Cheques</td>
                <td class="text-right"><strong>{{listaMovimientosResumen.monto_cheque | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Depositos</td>
                <td class="text-right"><strong>{{listaMovimientosResumen.monto_deposito | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Transferencia</td>
                <td class="text-right"><strong>{{listaMovimientosResumen.monto_transferencia | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr *ngFor="let ban of listaMovimientosResumen.bancos">
                <td style="font-size: 12px; padding-left: 20px;">
                  {{ ban.nombre }}
                </td>
                <td class="text-right" style="font-size: 12px; padding-left: 20px;">
                  {{ ban.monto_transferencia | numerico}}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Credito</td>
                <td class="text-right"><strong>{{listaMovimientosResumen.monto_credito | numerico}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>Diferencial (+/-)</td>
                <td align="right"><strong>$ {{listaMovimientosResumen.diferencia_monto_ingreso | numerico}}</strong></td>
                <td align="right"><strong>$ {{listaMovimientosResumen.diferencia_monto_egreso | numerico}}</strong></td>
              </tr>
              <tr>
                <td>Pago a Cuenta Utilizado</td>
                <td></td>
                <td class="text-right"><strong>{{listaMovimientosResumen.pago_cuenta_utilizado | numerico}}</strong>
                </td>
              </tr>
              <tr>
                <td>Gasto</td>
                <td></td>
                <td class="text-right"><strong>{{listaMovimientosResumen.gasto | numerico}}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- RETIROS / DEPOSITOS -->
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientosRetirosDeposito">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col" style="min-width: 350px;">
                  RETIROS / DEPOSITOS
                </th>
                <th scope="col" class="text-right">Ingresos</th>
                <th scope="col" class="text-right">Egresos</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="100%" style="text-align: center" *ngIf="loading">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
                <td colspan="100%" style="text-align: center"
                  *ngIf="!loading && listaMovimientosRetirosDeposito?.length === 0">
                  No se encontró información
                </td>
              </tr>
              <tr>
                <td>Pagos Menores a Proveedor</td>
                <td></td>
                <td class="text-right"><strong>{{listaMovimientosRetirosDeposito.pago_proveedores | numerico}}</strong>
                </td>
              </tr>
              <tr>
                <td>Retiros / Pagos a Caja Chica</td>
                <td></td>
                <td class="text-right"><strong>{{listaMovimientosRetirosDeposito.pago_caja_chica | numerico}}</strong>
                </td>
              </tr>
              <tr>
                <td>Depositos de Efectivos</td>
                <td></td>
                <td class="text-right"><strong>{{listaMovimientosRetirosDeposito.deposito_efectivo | numerico}}</strong>
                </td>
              </tr>
              <tr>
                <td>Protesto de Cheque</td>
                <td></td>
                <td class="text-right"><strong>{{listaMovimientosRetirosDeposito.monto_protesto_cheque | numerico}}</strong>
                </td>
              </tr>
              <tr>
                <td>Reverso de Pagos</td>
                <td></td>
                <td class="text-right"><strong>{{listaMovimientosRetirosDeposito.monto_reverso | numerico}}</strong>
                </td>
              </tr>
            </tbody>
            <tbody class="blue lighten-4" *ngIf="listaMovimientosTotal">
              <tr>
                <td class="text-right"><strong>TOTAL</strong></td>
                <td class="text-right"><strong>{{listaMovimientosTotal.total_ingreso | numerico}}</strong></td>
                <td class="text-right"><strong>{{listaMovimientosTotal.total_egreso | numerico}}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-footer" *ngIf="listaMovimientosRetirosDeposito">
      <div>
        <!-- <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm" (click)="documentoDownloadExcelPdf('XLS')">
          Excel
        </button> -->
        <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm" (click)="documentoDownloadExcelPdf('PDF')">
          PDF
        </button>
      </div>
    </div>
  </div>
</div>

<app-caja-diaria-modal-detalle></app-caja-diaria-modal-detalle>
